import { hubbleAPI } from './url'
const secureResource = hubbleAPI + 'secure/public/ct'
export default ($axios) => ({

  getShoppingList (shoppingListID) {
    return $axios.get(`${secureResource}/load-shopping-list/${shoppingListID}`)
  },

  createShoppingList () {
    return $axios.post(`${secureResource}/create-shopping-list`, {})
  },
  loadOrCreateShoppingList (shoppingListID) {
    if (shoppingListID) {
      return $axios.post(`${secureResource}/load-create-shopping-list/${shoppingListID}`, {})
    } else {
      return $axios.post(`${secureResource}/load-create-shopping-list`, {})
    }
  },

  addItemToShoppingList (shoppingListID, payload) {
    return $axios.post(`${secureResource}/shopping-list/add-item/${shoppingListID}`, payload)
  },
  // provide sku in payload
  removeItemFromShoppingList (shoppingListID, sku) {
    return $axios.put(`${secureResource}/shopping-list/remove-item/${shoppingListID}/${sku}`, {})
  },
  // provide sku and quantity in payload
  updateQuantityOfItem (shoppingListID, payload) {
    return $axios.put(`${secureResource}/shopping-list/update-quantity/${shoppingListID}`, payload)
  },
  deleteShoppingList(shoppingListID) {
    return $axios.delete(`${secureResource}/delete-shopping-list/${shoppingListID}`)
  },
  emptyShoppingList(shoppingListID) {
    return $axios.delete(`${secureResource}/empty-shopping-list/${shoppingListID}`)
  },
  updateShoppingListItemStatus(shoppingListID, sku, status, index) {
    return $axios.put(`${secureResource}/shopping-list/update-status/${shoppingListID}/${sku}/${status}/${index}`)
  }
})
